module.exports = __webpack_public_path__ + "static/media/kv-all-super-withdrawal.bfd53bd8.jpg";